import Vue from "vue";
import Router from "vue-router";
import Landing from "./views/examples/Landing.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(Router);

const legacyPaths = [
  "/sections",
  "/presentation",
  "/about-us",
  "/blog-post",
  "/blog-posts",
  "/contact-us",
  "/pricing-page",
  "/shopping-cart",
  "/ecommerce-page",
  "/product-page",
  "/landing-page",
  "/login-page",
  "/profile-page",
  "/xtrading-page",
  "/adnetwork-page",
  "/superlink-page",
  "/signup-page",
  "/error-page"
];

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        default: Landing,
        header: MainNavbar,
        footer: MainFooter
      }
    },
    ...legacyPaths.map(path => ({
      path,
      redirect: "/"
    })),
    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
